<template>
  <div class="page_body">
      <div class="data_main">
          <el-tabs v-model="listQuery.deliveryType" @tab-click="changeTab" class="pr0">
              <el-tab-pane label="京东仓配送" name="2" v-if="power[0].length > 0"></el-tab-pane>
              <el-tab-pane label="自有仓配送" name="1" v-if="power[1].length > 0"></el-tab-pane>
          </el-tabs>
          <div class="data_search mt24" v-if="(listQuery.deliveryType == 2 && power[0].indexOf('1')>=0) || (listQuery.deliveryType == 1 && power[1].indexOf('1')>=0)">
              <el-form ref="listQuery" :inline="true" :model="listQuery" size="small" label-width="72px">
                  <el-form-item label="水卡编号：" prop="cardNo">
                      <el-input v-model="listQuery.cardNo" placeholder="请输入水卡编号" @keyup.enter.native="toSearchList"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号：" prop="phone">
                      <el-input v-model="listQuery.phone" placeholder="请输入手机号" @keyup.enter.native="toSearchList"></el-input>
                  </el-form-item>
                  <el-form-item label="用户昵称：" prop="userName">
                      <el-input v-model="listQuery.userName" placeholder="请输入用户昵称" @keyup.enter.native="toSearchList"></el-input>
                  </el-form-item>
                  <el-form-item label="省份：" prop="province">
                      <el-select v-model="listQuery.province" @change="toSearchList">
                          <el-option label="全部" value=""></el-option>
                          <el-option v-for="(item,index) in proList" :key="index"
                          :label="item.name"
                          :value="item.name"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item label="下单时间：" prop="dateData2">
                    <el-date-picker
                            @change="toSearchList"
                            style="width: 100%"
                            v-model="dateData"
                            type="daterange"
                            range-separator="~"
                            value-format="yyyy-MM-dd"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="水卡状态：" prop="state">
                      <el-select v-model="listQuery.state" @change="toSearchList">
                          <el-option label="全部" value=""></el-option>
                          <el-option label="已发货" :value="2"></el-option>
                          <el-option label="配送中" :value="3"></el-option>
                          <el-option label="已完成" :value="4"></el-option>
                          <el-option label="理赔中" :value="11"></el-option>
                          <el-option label="理赔成功" :value="12"></el-option>
                          <el-option label="理赔驳回" :value="13"></el-option>
                          <el-option label="理赔完成" :value="14"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item class="last">
                      <el-button type="primary" :loading="isSearchLoading" @click="toSearchList()">查 询</el-button>
                      <el-button @click="resetSearch">重 置</el-button>
                  </el-form-item>
              </el-form>
          </div>

          <div class="data_group mt18">
              <el-button type="primary" size="small" @click="getExportOrder" v-if="(listQuery.deliveryType == 2 && power[0].indexOf('2')>=0) || (listQuery.deliveryType == 1 && power[1].indexOf('2')>=0)">批量导出</el-button>
              <el-button type="primary" size="small" @click="postConfirm" v-if="listQuery.deliveryType == 1 && power[1].indexOf('3')>=0" :disabled="selectedOpenItems.length==0">确认送达</el-button>
          </div>

          <div class="data_table mt18">
              <el-table ref="listTable" :data="listData" @select="select" style="width: 100%" v-loading="isRequestLoading" v-show="listQuery.deliveryType == 1">
                  <el-table-column width="70px" type="selection" align="center" :selectable="checkSelectable" v-if="power[1].indexOf('3')>=0"></el-table-column>
                  <el-table-column prop="cardNo" label="水卡编号" min-width="100" align="center"></el-table-column>
                  <el-table-column prop="spec" label="水卡规格" min-width="140px" align="center">
                  </el-table-column>
                  <el-table-column prop="companyName" label="采购单位" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="packUnit" label="发货数量" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="nickName" label="用户昵称" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="receiveName" label="收件人姓名" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="receivePhone" label="手机号" min-width="120px" align="center">
                  </el-table-column>
                  <el-table-column prop="remark" label="备注" min-width="120px" align="center">
                  </el-table-column>
                  <el-table-column label="下单时间" min-width="160px" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.deliveryTime | times}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="state" label="状态" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.state == 0">未启用</span>
                      <span v-if="scope.row.state == 1">未使用</span>
                      <span v-if="scope.row.state == 2">已发货</span>
                      <span v-if="scope.row.state == 3">配送中</span>
                      <span v-if="scope.row.state == 4">已完成</span>
                      <span v-if="scope.row.state == 11">理赔中</span>
                      <span v-if="scope.row.state == 12">理赔成功</span>
                      <span v-if="scope.row.state == 13">理赔驳回</span>
                      <span v-if="scope.row.state == 14">理赔完成</span>
                      <span v-if="scope.row.state == 9">已过期</span>
                      <span v-if="scope.row.state == 15">未激活</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="receiveProvince" label="省份" min-width="80px" align="center">
                  </el-table-column>
                  <el-table-column prop="receiveCity" label="市区县" min-width="80px" align="center">
                  </el-table-column>
                  <el-table-column prop="receiveAddress" label="用户地址" min-width="200px" align="center">
                  </el-table-column>
                  <el-table-column label="操作" align="center" min-width="80" fixed="right">
                    <template slot-scope="scope" v-if="selectedOpenItems.length==0">
                      <el-button type="text" @click="postConfirmOne(scope.row.id)" v-if="(scope.row.state == 2 || scope.row.state == 3) && power[1].indexOf('3')>=0">确认</el-button>
                    </template>
                  </el-table-column>
              </el-table>
              <el-table ref="listTable" :data="listData" style="width: 100%" v-loading="isRequestLoading" v-show="listQuery.deliveryType == 2">
                  <el-table-column prop="cardNo" label="水卡编号" min-width="100" align="center"></el-table-column>
                  <el-table-column prop="spec" label="水卡规格" min-width="140px" align="center">
                  </el-table-column>
                  <el-table-column prop="companyName" label="采购单位" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="packUnit" label="发货数量" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="nickName" label="用户昵称" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="receiveName" label="收件人姓名" min-width="100px" align="center">
                  </el-table-column>
                  <el-table-column prop="receivePhone" label="手机号" min-width="120px" align="center">
                  </el-table-column>
                  <el-table-column prop="remark" label="备注" min-width="120px" align="center">
                  </el-table-column>
                  <el-table-column label="下单时间" min-width="160px" align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.deliveryTime | times}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="state" label="状态" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.state == 0">未启用</span>
                      <span v-if="scope.row.state == 1">未使用</span>
                      <span v-if="scope.row.state == 2">已发货</span>
                      <span v-if="scope.row.state == 3">配送中</span>
                      <span v-if="scope.row.state == 4">已完成</span>
                      <span v-if="scope.row.state == 11">理赔中</span>
                      <span v-if="scope.row.state == 12">理赔成功</span>
                      <span v-if="scope.row.state == 13">理赔驳回</span>
                      <span v-if="scope.row.state == 14">理赔完成</span>
                      <span v-if="scope.row.state == 9">已过期</span>
                      <span v-if="scope.row.state == 15">未激活</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="receiveProvince" label="省份" min-width="80px" align="center">
                  </el-table-column>
                  <el-table-column prop="receiveCity" label="市区县" min-width="80px" align="center">
                  </el-table-column>
                  <el-table-column prop="receiveAddress" label="用户地址" min-width="200px" align="center">
                  </el-table-column>
                  <el-table-column prop="warehouseName" label="配送仓库" min-width="200px" align="center">
                  </el-table-column>
                  <el-table-column label="操作" align="center" min-width="80" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="text" @click="getDetail(scope.row.id)" v-if="scope.row.state != 0 && scope.row.state != 9 && scope.row.state != 1 && scope.row.state != 15">查看物流</el-button>
                    </template>
                  </el-table-column>
              </el-table>
          </div>

          <el-dialog class="popup_dialog" title="查看配送信息" :visible.sync="logisticsInfo" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" width="1000px">
            <div class="file-list" style="line-height: 25px;">
              <div>用户姓名：{{logistics.name}}</div>
              <div>用户地址：{{logistics.province+' '+logistics.city+' '+logistics.address}}</div>
              <!-- <div>配送仓库：{{logistics.logisticsCode}}</div> -->
              <div v-if="logistics.logisticsInfo && logistics.logisticsInfo.length>0">配送单号：{{logistics.logisticsInfo[0].waybillNo}}</div>
              <div>备注：{{logistics.remark?logistics.remark:'-'}}</div>
            </div>
            <div class="data_table log_table mt18" v-if="logistics.logisticsInfo && logistics.logisticsInfo.length>0">
              <el-table :data="logistics.logisticsInfo" style="width: 100%;padding:0"  height="400px">
                <el-table-column prop="operateTitle" label="进程"></el-table-column>
                <el-table-column prop="operateName" label="操作人"></el-table-column>
                <el-table-column prop="operateTime" label="时间"></el-table-column>
                <el-table-column prop="operateRemark" label="具体操作"></el-table-column>
              </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="logisticsInfo=false">关 闭</el-button>
            </div>
          </el-dialog>

          <pagination :size="listQuery.pageSize" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
      </div>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import {getPro,getUserOrder,getExportOrder,postConfirm,getOrderDetail} from '@/api'
import {mapState} from "vuex";
export default {
name: "contentArticleIndex",
data () {
  var validatePass2 = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.formPwd.password) {
      callback(new Error('两次输入密码不一致!'));
    } else {
      callback();
    }
  };  
  return {
    logisticsInfo:false,
    logistics:{},
    dateData:[],
    dateData2:[],
    listQuery: {
      state:'',
      phone:'',
      deliveryTimeStart:'',
      deliveryTimeEnd:'',
      province:'',
      userName:'',
      cardNo: '',
      deliveryType: '2',
      selfFlag:false,
      page: 1,
      pageSize: 10
    },
    pages: {
      total: 0,
      pages: 0
    },
    option:[],
    isSubmitLoading:false,
    isSearchLoading: false,
    isRequestLoading: false,
    listData: [],
    formDate:{
      id:'',
      endDate:''
    },
    delay:false,
    formPwd:{
      id:'',
      password:'',
      newPassWordAgain:'',
    },
    password:false,
    rulesPwd: {
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
      ],
      newPassWordAgain: [
        { validator: validatePass2, trigger: 'blur' }
      ]
    },
    rules: {
      endDate: [
        { required: true, message: '请选择日期', trigger: 'change' },
      ],
    },
    addCard:false,
    allowedFileTypes: ['xls','xlsx'],
    rulesData:{
      cardNo: [
        {required: true, message: '请输入10位数卡号', trigger: 'blur'}
      ],
      password: [
        {required: true, message: '请输入8位数密码', trigger: 'blur'}
      ],
      companyName: [
        {required: true, message: '请输入采购单位', trigger: 'blur'}
      ],
      sellType: [
        {required: true, message: '请输入销售类型', trigger: 'blur'}
      ],
      // deliveryArea: [
      //   {required: true, message: '请添加使用区域', trigger: 'blur'}
      // ],
      price: [
        {required: true, message: '请输入价格', trigger: 'blur'}
      ],
      dateData2:[
        {required: true, message: '请选择使用期限', trigger: 'change'}
      ],
      cardId:[
        {required: true, message: '请选择所属类型', trigger: 'change'}
      ],
    },
    formData:{
      cardNo:'',
      password:'',
      companyName:'',
      sellType:'',
      beginDate:'',
      endDate:'',
      price:'',
      cardId:'',
      dateData2:[],
    },
    selectedOpenItems:[],
    addCardMore:false,
    rulesDataMore:{
      num: [
        {required: true, message: '请输入生成数量', trigger: 'blur'}
      ],
      cardNo: [
        {required: true, message: '请输入首位卡号', trigger: 'blur'}
      ],
      cardId:[
        {required: true, message: '请选择所属类型', trigger: 'change'}
      ],
    },
    formDataMore:{
      num:0,
      cardNo:'',
      cardId:'',
    },
    exportDialog:false,
    exportFrom:{
      cardId:'',
      cardNo:'',
      deliveryType:'',
      deliveryArea:'',
      state:0,
    },
    activationCardMore:false,
    rulesDataMoreOther:{
      cardNo: [
        {required: true, message: '请输入卡号区间首位', trigger: 'blur'}
      ],
      cardNo1: [
        {required: true, message: '请输入卡号区间末尾', trigger: 'blur'}
      ],
      companyName: [
        {required: true, message: '请输入采购单位', trigger: 'blur'}
      ],
      sellType: [
        {required: true, message: '请输入销售类型', trigger: 'blur'}
      ],
      price: [
        {required: true, message: '请输入价格', trigger: 'blur'},
        // { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输⼊正确的格式,可保留两位⼩数', trigger: 'blur' }
      ],
      dateData2:[
        {required: true, message: '请选择使用期限', trigger: 'change'}
      ]
    },
    formDataMoreOther:{
      num:'-1',
      cardNo:'',
      cardNo1:'',
      companyName:'',
      sellType:'',
      beginDate:'',
      endDate:'',
      price:'',
      dateData2:[],
    },
    power:null,
    proList:[],
  }
},
computed: {
  ...mapState({
    listKeepAlive: state => state.app.listKeepAlive,
  })
},
filters:{
  times(e){
    if (e) {
      return e
    } else {
      return '-'
    }
  }
},
activated () {
  this.getPro()
},
created(){
  this.power = JSON.parse(localStorage.getItem('userRole')).power[2]
  if (this.power[0].length == 0) {
    this.listQuery.deliveryType = '1'
  }
  this.$nextTick(() => {
    document.querySelector('.el-table-column--selection').querySelector(".cell").innerHTML = '选择'
  })
},
methods: {
  getDetail(id){
    getOrderDetail(id).then(res=>{
      this.logistics = res.data
      this.logisticsInfo = true
    })
  },
  postConfirmOne(id){
    this.$confirm('是否确认送达?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        postConfirm({data:[id]}).then(res=>{
          if (res.code == 0) {
            this.toSearchList()
          }
        })
      }).catch(() => {});
  },
  postConfirm(){
    let arr = []
    this.selectedOpenItems.forEach(i=>{
      arr.push(i.id)
    })
    postConfirm({data:arr}).then(res=>{
      if (res.code == 0) {
        this.selectedOpenItems = []
        this.toSearchList()
      }
    })
  },
  checkSelectable (row) {
    if (row.state == 2 || row.state == 3) {
        return true
    } else {
        return false
    }
  },
  getPro(){
    getPro().then(res=>{
      this.proList = res.data
      this.getOrder()
    })
  },
  changeTab(){
    this.toSearchList()
  },
  getExportOrder(){
    // let form = {
    //     cardId:this.exportFrom.cardId,
    //     cardNo:this.exportFrom.cardNo,
    //     deliveryType:this.exportFrom.deliveryType,
    //     province:this.exportFrom.deliveryArea,
    //     state:this.exportFrom.state,
    // }
    getExportOrder(this.listQuery).then(res=>{
      if (res) {
        this.$message.success('导出成功')
        this.exportDialog = false
      }
    })
  },
  pageChange (e) {
    this.listQuery.page = e.current
    this.listQuery.pageSize = e.size
    this.getOrder()
  },
  toSearchList () {
    this.listQuery.page = 1
    this.isSearchLoading = true
    this.getOrder()
  },
  resetSearch(){
    this.$refs['listQuery'].resetFields()
    this.dateData = []
  },
  getOrder(){
    if (this.dateData && this.dateData.length>0) {
      this.listQuery.deliveryTimeStart = this.dateData[0]
      this.listQuery.deliveryTimeEnd = this.dateData[1]+" 23:59:59"
    } else {
      this.listQuery.deliveryTimeStart = ''
      this.listQuery.deliveryTimeEnd = ''
    }
    getUserOrder(this.listQuery).then(res=>{
      this.isSearchLoading = false
      this.listData = res.data.records
      this.pages.total = res.data.total
      this.pages.pages = res.data.pages
      if (this.listQuery.deliveryType == 1) {
          this.selectedPreExisting(this.selectedOpenItems)
      }
    }).catch(()=>{
      // console.log(err)
        this.isSearchLoading = false
    })
  },
    //选中table已有数据
  selectedPreExisting (rows) {
    if (rows.length > 0) {
      //这里使用this.$nextTick是防止表格未渲染完成就执行，导致无法添加选中效果
      this.$nextTick(() => {
        rows.forEach(row => {
          //判断row是存在当前tableData
          let selectedItem = this.listData.find(item => item.id == row.id)
          this.$refs['listTable'].toggleRowSelection(selectedItem);
        });
      })
    } else {
      this.$refs['listTable'].clearSelection();
    }
  },
  //表格单选
  select (selection, row) {
    //因为翻页之后，点选时selection会出现undefined,所以这里需要进行判断
    //这里可以通过判断选择selection中有没有row，就可以判断出是增加还是删减
    if (selection && selection.find(item => item && (item.id == row.id))) {
      this.addRows([row])
    } else {
      this.deleteRows([row])
    }
  },
  //添加选中
  addRows (rows) {
    rows.forEach(row => {
      //过滤，当selectedItems有此条数据时，则直接返回，不执行添加
      if (this.selectedOpenItems.find(item => item.id == row.id)) { return }
      this.selectedOpenItems.push(row)
    });
  },
  //取消选中
  deleteRows (rows) {
    //当selectedItems为空数组时，不执行删除
    if (this.selectedOpenItems.length == 0) { return }
    rows.forEach(row => {
      this.selectedOpenItems.forEach((value,index)=>{
          if (value.id == row.id) {
            this.selectedOpenItems.splice(index,1)
          }
      });
    })
  },
},
components: {
  pagination
}
}
</script>
<style lang="scss" scoped>
.andNumber{
  /deep/ .el-form-item__label{
    text-align: center !important;
    position: relative;
    &::before{
      position: absolute;
      left: 0;
    }
  }
}
</style>